import type { ThemeMode } from '@shared/app-config/types'
import type { CmdLogPayload } from '@shared/logging/types'
import { createNanoEvents } from 'nanoevents'

export interface GlobalEvents {
  /**
   * Fires when auth is invalid
   * @param error
   */
  authExpired: (error: unknown) => void
  /**
   * Fires when critical error occured preventing app to work
   * @param error
   */
  error: (error: unknown) => void
  /**
   * Fires when app started
   */
  ready: () => void
  /**
   * Fires when initial route resolves and page starts rendering.
   * Later than `ready` — use this to hide splash screens.
   */
  load: () => void
  /**
   * Fires when AppConfig is updated dynamically (e.g. autoload tags)
   */
  configUpdated: () => void
  /**
   * Fires when a structured log entry is received from a child iframe or the host itself.
   */
  log: (entry: CmdLogPayload) => void
  /**
   * Fires when the active forced theme mode changes ('auto' | 'light' | 'dark').
   * Persist-agnostic: the host emits this so embedders (e.g. the facade shell) can
   * react to or persist theme changes without the host knowing any storage details.
   */
  themeChanged: (mode: ThemeMode) => void
}

const globalEvents = createNanoEvents<GlobalEvents>()

export default globalEvents
